import React from 'react';
import { useSamarthDashboardContext } from 'utils/samarth-dashboard-context/hooks/useSamarthDashboardContext';
import WidgetWrapper from '../widget-wrapper/widget-wrapper';
import ChartSkeleton from '../../ui/chart-skeleton/chart-skeleton';
import SingleLineCharts from '../../ui/SinglelineCharts/singlelineCharts';
import SingleTabTable from '../../ui/SingleTabTable';
import styles from '../maiWidgets/mai-widget.module.css';

export default function ManpowerIndexWidget() {
  const { state } = useSamarthDashboardContext();
  const globalViewMode = state.viewMode.globalViewMode;
  const chartData = state.dashboardData.manpowerIndex;
  const loader = state.dashboardData.isLoading.manpowerIndex;

  return (
    <WidgetWrapper
      title="Manpower Index"
      isTableView={globalViewMode === 'table'}
      showFilterButton={true}
      infoText="MPI measures the expected manpower to the required manpower."
    >
      {loader ? (
        <ChartSkeleton />
      ) : (
        <div style={{ height: '100%' }}>
          {globalViewMode === 'graph' ? (
            <SingleLineCharts data={chartData} />
          ) : (
            <SingleTabTable
              data={chartData}
              keys={['week', 'value']}
              colorLogic={(value) => {
                if (value > 95) return styles.textGreen;
                if (value >= 90) return styles.textYellow;
                return styles.textRed;
              }}
            />
          )}
        </div>
      )}
    </WidgetWrapper>
  );
}
